var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "capterra-reviews-wrapper" }, [
    _c(
      "div",
      { staticClass: "capterra-reviews" },
      [
        _c("div", { staticClass: "title-and-subtitle" }, [
          _c(
            "div",
            {
              staticClass:
                "what-our-users-say d-flex align-items-end justify-content-center",
            },
            [
              _vm._m(0),
              _c("p", { staticClass: "m-0 font-tragic-marker" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("pages.pricing.capterraReviews.whatOurUsersSay")
                    ) +
                    " "
                ),
              ]),
            ]
          ),
          _c("div", { staticClass: "text-center" }, [
            _c("h1", { staticClass: "font-outfit-semi-bold m-0" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "pages.pricing.capterraReviews.yourIdeasAreInGoodHands"
                    )
                  ) +
                  " "
              ),
            ]),
          ]),
        ]),
        _c(
          "el-row",
          { staticClass: "d-flex flex-wrap", attrs: { gutter: 30 } },
          [
            _c(
              "el-col",
              { staticClass: "d-flex", attrs: { md: 12, lg: 8 } },
              [
                _c("capterra-review-card", {
                  staticClass: "w-100 d-flex",
                  attrs: {
                    title: _vm.capterraReviews.jonathan.title,
                    description: _vm.capterraReviews.jonathan.description,
                    link: _vm.capterraReviews.jonathan.link,
                    user: _vm.capterraReviews.jonathan.user,
                  },
                }),
              ],
              1
            ),
            _c(
              "el-col",
              { staticClass: "d-flex", attrs: { md: 12, lg: 8 } },
              [
                _c("capterra-review-card", {
                  staticClass: "w-100 d-none d-md-flex",
                  attrs: {
                    title: _vm.capterraReviews.emily.title,
                    description: _vm.capterraReviews.emily.description,
                    link: _vm.capterraReviews.emily.link,
                    user: _vm.capterraReviews.emily.user,
                  },
                }),
              ],
              1
            ),
            _c(
              "el-col",
              { staticClass: "d-flex", attrs: { md: 12, lg: 8 } },
              [
                _c("capterra-review-card", {
                  staticClass: "w-100 d-none d-lg-flex",
                  attrs: {
                    title: _vm.capterraReviews.john.title,
                    description: _vm.capterraReviews.john.description,
                    link: _vm.capterraReviews.john.link,
                    user: _vm.capterraReviews.john.user,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "position-relative" }, [
      _c("img", {
        staticClass: "horn-img",
        attrs: {
          src: require("@/assets/img/pricing/capterra-reviews/horn.svg"),
          alt: "horn",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }